import { Component, inject, signal } from '@angular/core';
import { NgxButtonComponent } from '@digipay/ngx-button';

import { BaseComponent } from '../../../../components/core/components/base/base.component';
import {
  CAMPAIGN_AGREEMENT_ROUTE,
  COLLATERAL_ROUTE,
  COLLATERAL_WAITING_ROUTE,
  HOME_ROUTE,
  PROVIDER_NOT_AVAILABLE_ROUTE,
} from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { CollateralService } from '../../../collateral/services/collateral.service';
import { IProcessData } from '../../../collateral/models/process-data.interface';
import { ECollateralPage } from '../../../collateral/models/collatetral-page.enum';
import { NgxCountDownComponent } from '@digipay/ngx-count-down';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { HomeService } from '../../../home/services/home.service';
import { PinInputComponent } from '../../../../shared/components/pin-input/pin-input.component';

@Component({
  selector: 'app-otp',
  templateUrl: './campaign-otp.component.html',
  styleUrls: ['./campaign-otp.component.scss'],
  standalone: true,
  imports: [NgxButtonComponent, NgxAppBarComponent, NgxCountDownComponent, PinInputComponent],
})
export class CampaignOtpComponent extends BaseComponent {
  inProgress = true;
  otp = '';
  hasError = false;
  isLoading = false;

  state: {
    campaignCode?: string;
    userInfo?: any;
    countDown?: string;
    symbol: string;
    phoneNumber: string;
    coordinatorAction: string;
    data?: IProcessData;
  };
  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);
  homeService = inject(HomeService);
  errorMessage = signal('');
  countDown = signal(300);
  pageTitle: string;

  constructor(private collateralService: CollateralService) {
    super();
    this.state = this.routeState.getAll();
    this.countDown.set(+this.state?.countDown);
    if (!this.state.campaignCode && !this.state.coordinatorAction) {
      this.navigationService.navigate([HOME_ROUTE]);
    }
    this.state.campaignCode ? (this.pageTitle = 'ثبت‌نام در کارگزاری') : (this.pageTitle = 'امضای دیجیتال');
  }

  onChanged(val: string) {
    this.hasError = false;
    this.otp = val;
  }

  registerCustomer() {
    this.isLoading = true;
    //TODO
    if (this.state.campaignCode) {
      this.homeService
        .getCampaignProcess(this.state.campaignCode, null, {
          otpCode: this.otp,
        })
        .subscribe((res) => {
          if (res?.success) {
            if (res.result['action'] === 'error') {
              this.hasError = true;
              this.errorMessage.set(res.result.data['message']);
            } else {
              this.navigationService.navigateWithState([CAMPAIGN_AGREEMENT_ROUTE], {
                state: {
                  campaignCode: this.state.campaignCode,
                  userInfo: res.result.data.customerProfile,
                  agreements: res.result.data.contractEtfAgreements,
                },
              });
            }
          }
          this.isLoading = false;
        });
    } else {
      const data: IProcessData = {
        otpCode: this.otp,
        instrumentSymbol: this.state.symbol,
      };
      this.collateralService.process(data, this.state.coordinatorAction).subscribe((res) => {
        if (res?.success) {
          if (res.result['action'] === 'error') {
            this.hasError = true;
            this.errorMessage.set(res.result.data['message']);
          } else {
            switch (res.result.data.pageName) {
              case ECollateralPage.page_collateral_pending:
                this.navigationService.navigate([COLLATERAL_WAITING_ROUTE], {
                  state: {
                    symbol: this.state.symbol,
                  },
                });
                break;
            }
          }
        }

        this.isLoading = false;
      });
    }
  }

  resend() {
    if (this.state.campaignCode) {
      this.homeService.getCampaignProcess(this.state.campaignCode).subscribe(
        (res) => {
          if (res?.success) {
            if (!this.inProgress) {
              this.inProgress = true;
              this.countDown.set(+res.result.data.countdownInSeconds || 300);
            }
            this.hasError = false;
            this.errorMessage.set('');
          }
        },
        () => {
          this.navigationService.navigate([PROVIDER_NOT_AVAILABLE_ROUTE]);
        },
      );
    } else if (this.state.symbol) {
      const data: IProcessData = {
        instrumentSymbol: this.state.symbol,
      };
      this.collateralService.process(data, this.state.coordinatorAction).subscribe();
    }
  }

  onTimerStopped() {
    this.inProgress = false;
  }

  onBackHandler() {
    if (this.state?.symbol) {
      this.navigationService.navigate([COLLATERAL_ROUTE, this.state.symbol]);
    } else {
      this.navigationService.navigate([HOME_ROUTE]);
    }
  }
}
